import { useEffect, useState } from 'react';
import { getAutoCompleteSessionToken } from '../../services/geo/geo';

export interface UseAutoCompleteSessionTokenResult {
  data?: google.maps.places.AutocompleteSessionToken,
  error?: Error,
}

export default function useAutoCompleteSessionToken(apiKey: string | null): UseAutoCompleteSessionTokenResult {
  const [data, setData] = useState<google.maps.places.AutocompleteSessionToken | undefined>();
  const [error, setError] = useState<Error>();

  // we don't cache the result as it's forbidden by G and we don't cleanup effect as we can't cancel requests
  useEffect(() => {
    if (apiKey) {
      getAutoCompleteSessionToken(apiKey)
        .then(setData)
        .catch(setError);
    }
  }, [apiKey]);

  return {
    data,
    error,
  };
}
